const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Removed web-vitals dependency
    console.log('Web vitals reporting disabled');
  }
};

export default reportWebVitals;
